import BaseFeature from '../../foundation/base/base';

class Basket extends BaseFeature {
	constructor(element) {
		super(element);
		this.initDomCache();

		this.el = element;
		this.basket = this.el;
		this.body = window.features.dom.body;
		this.closeSlider = this.el.querySelector('[data-js="closeSlider"]');
		this.basketItems = this.el.querySelector('[data-js="basketItems"]');
		this.closeCard = this.el.querySelectorAll('[data-js="closeCard"]');
		this.basketTrigger = this.el.querySelector('[data-js="basketTrigger"]');
		this.slider = this.el.querySelector('[data-js="slider"]');
		this.basketAlert = this.el.querySelector('[data-js="basketAlert"]');
		this.body = document.querySelector('body');

		this.addClick();
	}

	addClick() {
		if (this.closeCard) {
			this.closeCard.forEach((closeElement) => {
				closeElement.addEventListener('click', () => {
					closeElement.parentNode.parentNode.classList.add('is-deleted-item');
				});
			});
		}

		if (this.basketTrigger && this.slider) {
			this.basketTrigger.addEventListener('click', (e) => {
				e.stopPropagation();
				// Collapsing menu if basket is triggered
				const searchTrigger = document.querySelector('.m-menu-list__item.is-active');
				if (searchTrigger) {
					searchTrigger.classList.remove('is-active');
				}
				this.slider.classList.add('is-active');
				this.body.classList.add('is-active-basket');
				this.basketTrigger.setAttribute('aria-expanded', 'true'); // Accessibility

				const gtmItems = [];
				const allCartLines = this.slider.querySelectorAll('li.m-basket__subregions-items[data-gtmname]');
				if (allCartLines) {
					allCartLines.forEach((cartLine) => {
						gtmItems.push({
							item_name: cartLine.dataset.gtmname,
							item_id: cartLine.dataset.gtmid,
							price: cartLine.dataset.gtmprice,
							quantity: cartLine.dataset.gtmquantity
						});
					});
				}
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					event: 'view_cart',
					ecommerce: {
						items: gtmItems
					}
				});
			});
		}
		if (this.closeSlider) {
			this.closeSlider.addEventListener('click', () => {
				this.slider.classList.remove('is-active');
				this.body.classList.remove('is-active-basket');
				this.basketTrigger.setAttribute('aria-expanded', 'false'); // Accessibility
			});
		}

		if (this.closeSlider) {
			document.querySelector('.o-main').addEventListener('click', () => {
				this.slider.classList.remove('is-active');
				this.body.classList.remove('is-active-basket');
				this.basketTrigger.setAttribute('aria-expanded', 'false'); // Accessibility
			});
		}

		// Disable tab if basket is empty
		if (!this.basketAlert) {
			this.basketTrigger.setAttribute('tabindex', '-1'); // Accessibility
		}

		// Accessibility
		window.addEventListener('keyup', (e) => {
			const isFocused = document.activeElement === this.basketTrigger;
			if (isFocused && e.keyCode === 13) {
				// Trigger the button element with a click
				this.basketTrigger.click();
			}
			if (e.keyCode === 27) {
				// Trigger the button element with a click
				this.closeSlider.click();
			}
		});
	}
}

export default Basket;
